/**
*
* Getters ProductFile Orange
*
*/

import {
  GET_PRODUCT_INFORMATIONS,
  GET_CURRENT_PRODUCT,
  GET_OPEN_PRODUCT,
  GET_ADD_TO_CART_BUTTON_STATE,
  GET_TRAD
} from './types/gettersTypes'

const getters = {
  [GET_PRODUCT_INFORMATIONS]: state => state.productInformations,
  [GET_CURRENT_PRODUCT]: state => state.currentProduct,
  [GET_OPEN_PRODUCT]: state => state.openProduct,
  [GET_ADD_TO_CART_BUTTON_STATE]: state => state.addToCartButtonState,
  [GET_TRAD]: state => state.$t
}

export default getters